import { axios } from '@Root/API'

export const getMaritalStatus = () => {
	return axios.get(`marital-statuses`)
}
